import styled, { css } from 'styled-components';

import Button from '../../Button';

export const BlueButton = styled(Button)`
  height: ${({ theme }): string => theme.spacers!.spacer07};
  border-width: 2px;
  border-radius: 8px;
  background: ${({ theme }): string => theme.admanColors!.blue.dark.bg1[0]};
  color: ${({ theme }): string => theme.colors!.colorWhite};
  padding: 0 ${({ theme }): string => theme.spacers!.spacer04};
  font-family: InspireTWDC;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  margin-bottom: ${({ theme }): string => theme.spacers!.spacer01};

  span {
    font-family: InspireTWDC;
    letter-spacing: 0.1px;
  }

  &:disabled {
    background-color: ${({ theme }): string => theme.admanColors!.gray.light.bg3[5]};
    color: ${({ theme }): string => theme.admanColors!.gray.light.bg3[6]};

    path {
      fill: ${({ theme }): string => theme.admanColors!.gray.light.bg3[6]};
    }
  }

  &:hover {
    background: ${({ theme }): string => theme.admanColors!.blue.dark.bg2[0]};
  }

  &:active {
    background: ${({ theme }): string => theme.admanColors!.blue.dark.bg2[1]};
  }
`;

export const TextButton = styled(BlueButton)(
  ({ theme }) => css`
    background: transparent;
    color: ${theme.admanColors!.blue.dark.fg[2]};

    &:hover {
      background-color: ${theme.admanColors!.blue.light.bg[0]};
    }
  `
);

export const OutlineButton = styled(TextButton)`
  border-radius: 8px;
  border: 2px solid ${({ theme }): string => theme.admanColors!.blue.dark.fg[2]};

  &:disabled {
    border: none;
  }

  background: transparent;
`;
